import React, { Component } from 'react';
import CountUp from 'react-countup';
import { dbQuery  } from "../../api"
import { X, Check } from 'react-feather';
import {Link} from 'react-router-dom'

import '../../index.scss';

class BDBQueryCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ data: this.props.data ? this.props.data : 0, loading: false});                    

    };

    componentDidMount() {
        this.doQuery();
    }
    
    renderContent() {
        const {link, href} = this.props;
        
        if (link) return (<Link to={link}>{this.renderCube()}</Link>)
        else if (href) return (<a href={href} target="_blank" rel="noopener noreferrer">{this.renderCube()}</a>)
        else return (<>{this.renderCube()}</>)
    }
    renderCube() {
        const {title, subtitle, altsubtitle, icon, bg, numAfter} = this.props;
        const {data} = this.state;
        return (
    
        <div className="card o-hidden widget-cards">
            <div className={`${bg} card-body`}>
                <div className="media static-top-widget row">
                    <div className="icons-widgets col-3">
                        <div className="align-self-center text-center">{icon}</div>
                    </div>
                    <div className="media-body col-9"><span className="m-0"><h3 >{title}</h3></span>
                        <h3 className="mb-0">
                            {this.qType === 'none' &&  <small> {subtitle}</small>} 
                            {!numAfter && this.qType === 'number' && <><CountUp className="counter" end={data} /><small> {subtitle}</small></>}
                            {this.qType === 'boolean' && (data !== 0 
                            ?  <><Check /><small> {altsubtitle}</small></>
                            :  <><X /><small> {subtitle}</small></>)
                            }
                            {numAfter && this.qType === 'number' && <><small> {subtitle}</small><CountUp className="counter" end={data} /></>}                            
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        )
    }
    render(){
        if (this.state.loading) { return null; }
        if (this.props.colClass) return (<div className="col-12 col-md-6 col-lg-4 col-xl-4 ">{this.renderContent()}</div>)
        else return (<>{this.renderContent()}</>)
    }
}

export default BDBQueryCube;